import { AccountInfo } from 'pages/account/account-info';
import AuthRequired from 'pages/authentication/components/auth-required';

export default function AccountInfoPage() {
  return (
    <AuthRequired>
      <AccountInfo />
    </AuthRequired>
  );
}
